
export const multiProtocolTip = '三方协议包括Dubbo、bRPC、Thrift等';
